import { Helmet } from 'react-helmet-async';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { NotificationBanner } from '@/components/layout/NotificationBanner';
import { AlertBanner } from '@/components/layout/AlertBanner';
import { Hero } from '@/components/sections/Hero';
import { Welcome } from '@/components/sections/Welcome';
import { Mission } from '@/components/sections/Mission';

export function Index() {

  return (
    <>
      <Helmet>
        <title>Home | Simsbury Airport</title>
        <meta name="description" content="​Simsbury Airport is operated by the non-profit Simsbury Flying Club. Available are a flight school, 24/7 self-serve 100LL fuel, pilot lounge with WiFi, runway lighting​ and a maintenance operation." />
        <meta name="keywords" content="Flight School, Fuel, Simsbury Airport, Simsbury Fly-In" />
        <meta name="format-detection" content="telephone=no" />
        <meta name="skype_toolbar" content="skype_toolbar_parser_compatible" />
        
        {/* Open Graph meta tags */}
        <meta property="og:title" content="Home | Simsbury Airport" />
        <meta property="og:description" content="​Simsbury Airport is operated by the non-profit Simsbury Flying Club. Available are a flight school, 24/7 self-serve 100LL fuel, pilot lounge with WiFi, runway lighting​ and a maintenance operation." />
        <meta property="og:url" content="https://www.simsburyairport.com" />
        <meta property="og:site_name" content="Simsbury Airport" />
        <meta property="og:type" content="website" />
        
        {/* Twitter Card meta tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Home | Simsbury Airport" />
        <meta name="twitter:description" content="​Simsbury Airport is operated by the non-profit Simsbury Flying Club. Available are a flight school, 24/7 self-serve 100LL fuel, pilot lounge with WiFi, runway lighting​ and a maintenance operation." />
      </Helmet>
      
      <div className="min-h-screen bg-gray-50">
        {/* Notification Banner */}
        <NotificationBanner />
        
        {/* Alert Banner */}
        <AlertBanner />
        
        {/* Main Header */}
        <Header />
        
        {/* Hero Section with Aerial Airport Photo */}
        <Hero />
        
        {/* Welcome Section */}
        <Welcome />
        
        {/* Mission Section */}
        <Mission />
        
        <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
          <div className="px-4 py-6 sm:px-0">
            {/* Main content will be added in future iterations */}
          </div>
        </main>
        
        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}